import { all } from 'redux-saga/effects';
import atmServiceWorker from './atmLocationsSaga';

export default function* rootSaga(action) {
	yield all([atmServiceWorker(action)]);
}
